export const hamiltonZipcodeConfig = [
  {
    name: "Arcadia",
    postalCode: 46030,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 40.178, longitude: -86.041 },
  },
  {
    name: "Atlanta",
    postalCode: 46031,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 40.21, longitude: -86.019 },
  },
  {
    name: "Carmel",
    postalCode: 46032,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 39.971, longitude: -86.125 },
  },
  {
    name: "Carmel",
    postalCode: 46033,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 39.974, longitude: -86.083 },
  },
  {
    name: "Cicero",
    postalCode: 46034,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 40.13, longitude: -86.038 },
  },
  {
    name: "Fishers",
    postalCode: 46038,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 39.957, longitude: -86.023 },
  },
  {
    name: "Noblesville",
    postalCode: 46060,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 40.056, longitude: -86.016 },
  },
  {
    name: "Noblesville",
    postalCode: 46061,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 40.072, longitude: -86.052 },
  },
  {
    name: "Sheridan",
    postalCode: 46069,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 40.135, longitude: -86.221 },
  },
  {
    name: "Westfield",
    postalCode: 46074,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 40.049, longitude: -86.15 },
  },
  {
    name: "Carmel",
    postalCode: 46082,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 40.072, longitude: -86.052 },
  },
  {
    name: "Indianapolis",
    postalCode: 46280,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 39.942, longitude: -86.116 },
  },
  {
    name: "Indianapolis",
    postalCode: 46288,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 39.935, longitude: -86.163 },
  },
  {
    name: "Indianapolis",
    postalCode: 46290,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 39.935, longitude: -86.163 },
  },
  {
    name: "Fishers",
    postalCode: 46037,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 39.956, longitude: -85.96 },
  },
  {
    name: "Noblesville",
    postalCode: 46062,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 40.062, longitude: -86.055 },
  },
  {
    name: "Fishers",
    postalCode: 46085,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 39.956, longitude: -86.014 },
  },
  {
    name: "Indianapolis",
    postalCode: 46262,
    country: "United States",
    state: "Indiana",
    county: "Hamilton",
    coordinates: { latitude: 39.768, longitude: -86.158 },
  },
];
